import React from 'react';
import { Card } from '../UI/Card';
import { Building, GraduationCap, Presentation, Award, Handshake, Tent } from 'lucide-react';
export const TrainingFormats = () => {
  const formats = [{
    title: 'Corporate Workshops',
    icon: <Building className="w-8 h-8 text-primary" data-id="element-1119" />,
    description: 'Intensive, focused sessions designed to solve specific organizational challenges.'
  }, {
    title: 'Bootcamps',
    icon: <GraduationCap className="w-8 h-8 text-primary" data-id="element-1120" />,
    description: 'Multi-day immersive learning experiences for rapid skill acquisition.'
  }, {
    title: 'Masterclasses',
    icon: <Presentation className="w-8 h-8 text-primary" data-id="element-1121" />,
    description: 'Expert-led deep dives into specialized topics for advanced professionals.'
  }, {
    title: 'Certification Programs',
    icon: <Award className="w-8 h-8 text-primary" data-id="element-1122" />,
    description: 'Structured curricula culminating in recognized credentials.'
  }, {
    title: 'Institutional Partnerships',
    icon: <Handshake className="w-8 h-8 text-primary" data-id="element-1123" />,
    description: 'Long-term collaborative learning frameworks for schools and organizations.'
  }, {
    title: 'Retreat Trainings',
    icon: <Tent className="w-8 h-8 text-primary" data-id="element-1124" />,
    description: 'Off-site immersive experiences blending team building with capacity development.'
  }];
  return <section className="py-20 bg-white" data-id="element-1125">
      <div className="container mx-auto px-4" data-id="element-1126">
        <div className="text-center mb-16 scroll-animate" data-id="element-1127">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4 font-heading" data-id="element-1128">
            Flexible Learning Formats
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1129">
            We deliver our programs in ways that best suit your team's needs and
            operational realities.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-1130">
          {formats.map((format, index) => <Card key={index} className="scroll-animate hover-lift border-2 border-gray-100 hover:border-primary/20" style={{
          transitionDelay: `${index * 100}ms`
        }} data-id="element-1131">
              {format.icon}
              <h3 className="mt-4 text-xl font-semibold" data-id="element-1132">{format.title}</h3>
              <p className="mt-2 text-gray-600" data-id="element-1133">{format.description}</p>
              <div className="flex flex-col items-center text-center p-4" data-id="element-1134">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-6" data-id="element-1135">
                  {format.icon}
                </div>
                <h3 className="text-xl font-bold text-navy mb-3" data-id="element-1136">
                  {format.title}
                </h3>
                <p className="text-gray-600" data-id="element-1137">{format.description}</p>
              </div>
            </Card>)}
        </div>

        <div className="max-w-3xl mx-auto bg-navy text-white rounded-2xl p-8 md:p-12 text-center scroll-animate" data-id="element-1138">
          <h3 className="text-2xl font-bold mb-6" data-id="element-1139">Delivery Modes</h3>
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8" data-id="element-1140">
            <div className="flex items-center gap-3 bg-white/10 px-6 py-3 rounded-full w-full md:w-auto justify-center" data-id="element-1141">
              <span className="w-3 h-3 rounded-full bg-green-400" data-id="element-1142"></span>
              <span className="font-medium text-lg" data-id="element-1143">On-site</span>
            </div>
            <div className="flex items-center gap-3 bg-white/10 px-6 py-3 rounded-full w-full md:w-auto justify-center" data-id="element-1144">
              <span className="w-3 h-3 rounded-full bg-blue-400" data-id="element-1145"></span>
              <span className="font-medium text-lg" data-id="element-1146">Virtual</span>
            </div>
            <div className="flex items-center gap-3 bg-white/10 px-6 py-3 rounded-full w-full md:w-auto justify-center" data-id="element-1147">
              <span className="w-3 h-3 rounded-full bg-purple-400" data-id="element-1148"></span>
              <span className="font-medium text-lg" data-id="element-1149">Hybrid</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
};